import { LensLogo } from "@/components/LensLogo";
import { cn } from "@/lib/utils";
import { Outlet } from "react-router";

export const Authentication = () => {
	return (
		<div className="relative flex min-h-svh w-full items-center justify-center p-6 md:p-10 bg-[hsl(var(--primary))]">
			<div className="w-full max-w-sm">
				<div className={cn("flex flex-col gap-y-6")}>
					<div className="h-8">
						<LensLogo color="hsl(var(--secondary))" />
					</div>
					<Outlet />
					<div className="text-white/70 text-xs flex justify-center gap-1">
						<span>Powered by</span>
						<a href="https://www.drypdata.com" className="font-bold hover:underline">
							Dryp
						</a>
					</div>
				</div>
			</div>
		</div>
	);
};
